// extracted by mini-css-extract-plugin
export default {"legend":"components-hotel-channel-pricing-charts-channel-discounts-module__legend"};